import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {UtishaAuthProvider} from "src/app/services/user/user.service";
import { LoginChoiceButtonComponent } from './button/login-choice-button.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-login-choice',
    templateUrl: './login-choice.component.html',
    styleUrls: ['./login-choice.component.scss'],
    imports: [LoginChoiceButtonComponent, TranslatePipe]
})
export class LoginChoiceComponent implements OnInit {

  @Input() title: string;
  @Output() selected = new EventEmitter<UtishaAuthProvider>()

  constructor() { }

  ngOnInit(): void {
  }

}
